'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagingServiceSettings = void 0;
class MessagingServiceSettings {
    constructor({ id, sleekTemplateId, couriersNotificationId, name, description }) {
        this.id = id;
        this.sleekTemplateId = sleekTemplateId;
        this.couriersNotificationId = couriersNotificationId;
        this.name = name;
        this.description = description;
    }
    getSleekTemplateId(defaultValue) {
        if (this.sleekTemplateId != undefined && this.sleekTemplateId != null) {
            return this.sleekTemplateId;
        }
        if (defaultValue != undefined && defaultValue != null) {
            return defaultValue;
        }
        return null;
    }
    getCouriersNotificationId(defaultValue) {
        if (this.couriersNotificationId != undefined &&
            this.couriersNotificationId != null) {
            return this.couriersNotificationId;
        }
        if (defaultValue != undefined && defaultValue != null) {
            return defaultValue;
        }
        return null;
    }
    getName(defaultValue) {
        if (this.name != undefined && this.name != null) {
            return this.name;
        }
        if (defaultValue != undefined && defaultValue != null) {
            return defaultValue;
        }
        return null;
    }
    getDescription(defaultValue) {
        if (this.description != undefined && this.description != null) {
            return this.description;
        }
        if (defaultValue != undefined && defaultValue != null) {
            return defaultValue;
        }
        return null;
    }
}
exports.MessagingServiceSettings = MessagingServiceSettings;
//# sourceMappingURL=messaging-service-setting.model.js.map